"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseDialogActions = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var BaseDialogActions_style_1 = __importDefault(require("./BaseDialogActions.style"));
/**
 * BaseDialogActions molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-basedialog-basedialogactions--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/BaseDialog/BaseDialogActions Source}
 */
var BaseDialogActions = function (_a) {
    var className = _a.className, children = _a.children;
    var classes = (0, BaseDialogActions_style_1.default)();
    if (!children) {
        return null;
    }
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)(className, classes.root) }, { children: children }));
};
exports.BaseDialogActions = BaseDialogActions;
